import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ArrowRight, X } from "lucide-react";

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");

  const projects = [
    // Kitchen (2)
    {
      id: 1,
      category: "kitchen",
      title: "White Cabinet Kitchen",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/sddnmrc3_Kitchen%203.jpg",
    },
    {
      id: 2,
      category: "kitchen",
      title: "Modern Kitchen Renovation",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/3pzgvf94_Kitchen%204.jpg",
    },
    // Bathroom (8)
    {
      id: 3,
      category: "bathroom",
      title: "Elegant Tile Shower",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/bxv14apu_Bathroom%201.jpg",
    },
    {
      id: 4,
      category: "bathroom",
      title: "Walk-In Shower Design",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/wptt24bw_Bathroom%202.jpg",
    },
    {
      id: 5,
      category: "bathroom",
      title: "Custom Tile Work",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/bbypkr5a_Bathroom%203.jpg",
    },
    {
      id: 6,
      category: "bathroom",
      title: "Shower Enclosure",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/mnjxmcy6_Bathroom%204.jpg",
    },
    {
      id: 7,
      category: "bathroom",
      title: "Modern Bath Renovation",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/xn7g821k_Bathroom%205.jpg",
    },
    {
      id: 8,
      category: "bathroom",
      title: "Marble Tile Shower",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/awwfoh91_Bathroom%207.jpg",
    },
    {
      id: 9,
      category: "bathroom",
      title: "Black Frame Glass Shower",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/jpcfu36d_Bathroom%208.jpg",
    },
    {
      id: 10,
      category: "bathroom",
      title: "Vanity & Storage",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/1enh28hh_Bathroom%209.jpg",
    },
    // General Contracting (4)
    {
      id: 11,
      category: "general",
      title: "Stone Fireplace Surround",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/3bi45rkx_GC1.jpg",
    },
    {
      id: 12,
      category: "general",
      title: "Custom Stone Feature",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/qycmn6i2_GC2.jpg",
    },
    {
      id: 13,
      category: "general",
      title: "Fireplace Renovation",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/3om6i4uf_GC3.jpg",
    },
    {
      id: 14,
      category: "general",
      title: "Stone Wall Installation",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/w71pghey_GC4.jpg",
    },
    // Flooring (3)
    {
      id: 15,
      category: "flooring",
      title: "Tile Floor Installation",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/clo2sul9_Flooring%201.jpg",
    },
    {
      id: 16,
      category: "flooring",
      title: "Modern Floor Tile",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/g887xy51_Flooring%202.jpg",
    },
    {
      id: 17,
      category: "flooring",
      title: "Custom Flooring Project",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/fl7bccii_Flooring%203.jpg",
    },
    // Drywall & Finishing (1)
    {
      id: 18,
      category: "finishing",
      title: "Grey Tile & Freestanding Tub",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/bxy3s7yw_D%26F%201.jpg",
    },
    // Additional Kitchen (2)
    {
      id: 19,
      category: "kitchen",
      title: "Two-Tone Kitchen with Hexagon Tile",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/hdqx1zgd_Kitchen%201.jpg",
    },
    {
      id: 20,
      category: "kitchen",
      title: "Subway Tile Backsplash Kitchen",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/z2xd7o61_Kitchen%202.jpg",
    },
    // Additional Bathroom (1)
    {
      id: 21,
      category: "bathroom",
      title: "Soaker Tub with Tile Surround",
      image: "https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/y3kwcg5q_BAthroom%206.jpg",
    },
  ];

  const filters = [
    { id: "all", label: "All Projects" },
    { id: "kitchen", label: "Kitchen" },
    { id: "bathroom", label: "Bathroom" },
    { id: "general", label: "General Contracting" },
    { id: "flooring", label: "Flooring" },
    { id: "finishing", label: "Drywall & Finishing" },
  ];

  const filteredProjects = activeFilter === "all" 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 md:py-28 bg-[#0f172a]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <p className="text-[#d97706] font-['Barlow_Condensed'] font-semibold uppercase tracking-widest mb-4">
              Our Work
            </p>
            <h1 className="font-['Barlow_Condensed'] text-5xl md:text-6xl font-bold text-white uppercase tracking-tight mb-6">
              Project Gallery
            </h1>
            <p className="text-xl text-slate-400 max-w-2xl">
              Browse our portfolio of completed renovation projects. Each project represents our commitment to quality craftsmanship and customer satisfaction.
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 bg-white border-b border-slate-200 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-wrap gap-3">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                data-testid={`filter-btn-${filter.id}`}
                className={`px-6 py-2 font-['Barlow_Condensed'] font-semibold uppercase tracking-wider text-sm transition-colors ${
                  activeFilter === filter.id
                    ? "bg-[#0f172a] text-white"
                    : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 md:py-24 bg-[#f8fafc]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="masonry-grid">
            {filteredProjects.map((project, index) => (
              <div 
                key={project.id}
                className="masonry-item group cursor-pointer"
                onClick={() => setSelectedImage(project)}
                data-testid={`gallery-item-${project.id}`}
              >
                <div className="relative overflow-hidden bg-white">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                      index % 3 === 0 ? "aspect-[4/5]" : "aspect-[4/3]"
                    }`}
                  />
                  <div className="absolute inset-0 bg-[#0f172a]/0 group-hover:bg-[#0f172a]/60 transition-colors flex items-end">
                    <div className="p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                      <span className="text-[#d97706] font-['Barlow_Condensed'] font-semibold uppercase tracking-wider text-sm">
                        {project.category.replace("-", " ")}
                      </span>
                      <h3 className="font-['Barlow_Condensed'] text-xl font-bold text-white uppercase mt-1">
                        {project.title}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <div className="text-center py-20">
              <p className="text-slate-500 text-lg">No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Image Modal */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden border-none">
          {selectedImage && (
            <div className="relative">
              <img 
                src={selectedImage.image} 
                alt={selectedImage.title}
                className="w-full"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0f172a] to-transparent p-8">
                <span className="text-[#d97706] font-['Barlow_Condensed'] font-semibold uppercase tracking-wider text-sm">
                  {selectedImage.category.replace("-", " ")}
                </span>
                <h3 className="font-['Barlow_Condensed'] text-2xl font-bold text-white uppercase mt-1">
                  {selectedImage.title}
                </h3>
              </div>
              <button 
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors"
                data-testid="modal-close-btn"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* CTA Section */}
      <section className="py-20 md:py-28 bg-[#0f172a]">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="font-['Barlow_Condensed'] text-4xl md:text-5xl font-bold text-white uppercase tracking-tight mb-6">
            Love What You See?
          </h2>
          <p className="text-xl text-slate-400 mb-10 max-w-2xl mx-auto">
            Let's discuss how we can create a similar transformation for your home. Get in touch for a free consultation.
          </p>
          <Link to="/contact">
            <Button 
              size="lg"
              className="bg-[#d97706] hover:bg-[#b45309] text-white font-['Barlow_Condensed'] font-bold uppercase tracking-wider h-14 px-10 btn-glow"
              data-testid="gallery-cta-btn"
            >
              Start Your Project
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default GalleryPage;
